const Drivers = () => import('@/modules/drivers');

export default [
  {
    path: '/entregadores',
    name: 'list-general-drivers',
    component: Drivers,
    props: true,
    meta: {
      isAvaliableInFranchisorMenu: false,
      isAvaliableInMenu: false,
      navbarTitle: 'Entregadores',
      menuData: {
        title: 'Entregadores',
        id: 'driversSidebar',
      },
      onlyCheckBoxClick: true,
    },
  },
  {
    path: '/franquia/entregadores',
    component: Drivers,
    name: 'list-drivers',
    meta: {
      navbarTitle: 'Entregadores',
      isAvaliableInMenu: false,
      menuData: {
        title: 'Entregadores',
        id: 'driversSidebar',
      },
      nameCity: true,
      onlyCheckBoxClick: true,
    },
  },
  {
    path: '/franquia/entregadores/relatorios',
    name: 'driver-reports',
    component: Drivers,
    meta: {
      navbarTitle: 'Entregadores',
      nameCity: true,
    },
  },
  {
    path: '/cadastrar-entregador',
    name: 'drivers-register',
    component: Drivers,
    meta: {
      isPublic: true,
      showSidebar: false,
    },
    beforeEnter (){
      window.location.href = 'https://deliverymuch.com.br';
    },
  },
  {
    path: '/termosdeuso',
    name: 'driver-terms-of-use',
    component: Drivers,
    meta: {
      isPublic: true,
      showSidebar: false,
    },
  },
  {
    path: '/politica-de-privacidade',
    name: 'driver-privacy-terms',
    component: Drivers,
    meta: {
      isPublic: true,
      showSidebar: false,
    },
  },
  {
    path: '/franquia/entregadores/:id/editar',
    name: 'driver-edit',
    component: Drivers,
    meta: {
      navbarTitle: 'Editar entregador',
    },
  },
  {
    path: '/franquia/entregadores/operador-logistico/:logisticOperatorId',
    component: Drivers,
    name: 'list-logistic-operator-drivers',
    props: true,
    meta: {
      navbarTitle: 'Entregadores',
    },
  },
];
